import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './firebase';
import GetAuth from './components/GetAuth';
import GetAdmin from './components/GetAdmin';
import './App.css';
import AllUsers from './components/users/AllUsers';
import AdminUsers from './components/users/AdminUsers';
import RegularUsers from './components/users/RegularUsers';
import ActivatedUsers from './components/users/ActivatedUsers';
import DeactivatedUsers from './components/users/DeactivatedUsers';
import AddTransaction from './components/users/AddTransaction';
import TransactionLog from './components/users/TransactionLog';
import UserInfo from './components/users/UserInfo';
import AdminProfile from './components/users/AdminProfile';

const App = () => {
  const [user, setUser] = useState(null); // State to manage the authenticated user
  const [loading, setLoading] = useState(true); // State to manage the loading state

  useEffect(() => {
    // Subscribe to authentication state changes
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // If user is authenticated, fetch user data from Firestore
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          // Set user state with user data
          setUser({ uid: user.uid, ...userDoc.data() });
        } else {
          console.log('No such document!');
        }
      } else {
        // If no user is authenticated, set user state to null
        setUser(null);
      }
      // Set loading state to false after checking authentication
      setLoading(false);
    });

    // Cleanup subscription on component unmount
    return () => unsubscribe();
  }, []);

  // Display loading indicator while fetching authentication state
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* Render GetAdmin if user is authenticated, otherwise render GetAuth */}
        <Route
          path="/*"
          element={user ? <GetAdmin user={user} setUser={setUser} /> : <GetAuth setUser={setUser} />}
        >
          {/* Define nested routes for different admin views */}
          <Route index element={<AllUsers />} /> {/* Default route */}
          <Route path="all-users" element={<AllUsers />} />
          <Route path="admin-users" element={<AdminUsers />} />
          <Route path="regular-users" element={<RegularUsers />} />
          <Route path="activated-users" element={<ActivatedUsers />} />
          <Route path="deactivated-users" element={<DeactivatedUsers />} />
          <Route path="add-transaction" element={<AddTransaction />} />
          <Route path="admin-profile" element={<AdminProfile />} />
          <Route path="user/:userId/transactions" element={<TransactionLog />} />
          <Route path="user/:userId" element={<UserInfo />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;